// removed by extract-text-webpack-plugin
module.exports = {"homePageContainer":"Home__homePageContainer___2cwKa","column":"Home__column___1xipn"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.scss
// module id = 1576
// module chunks = 0